module.exports = __webpack_public_path__ + "static/media/electronic-bill-on.2da7b241.svg";